import { useState } from 'react'
import { Box, Text, Button, IndustrialCard, Select, ChartCapRate } from '../..'
import { PopUpComparativeUniverseIndustrial } from './PopUpComparativeUniverseIndustrial';
import reloadIcon from '../../../../assets/icons/reload.svg'
import { useParams } from 'react-router-dom';
import { ChartCapRateIndustrial } from './ChartCapRateIndustrial';
import CapRateIndustrial from './CapRateIndustrial';
import { useApp } from '../../../../contexts';
import { translateText } from '../../../../helpers/util';


export const EvaluationCardIndustrial = ({ industrialId, handleVMVI }) => {

    const { accessToken } = useParams()
    const [period, setPeriod] = useState(12)
    const [reloadTrigger, setReloadTrigger] = useState(true)
    const [comparativeUniverse, setComparativeUniverse] = useState(null)
    const { userCountry, language, translations } = useApp()

    const handleReload = async () => {
        setReloadTrigger(!reloadTrigger)
    }

    const handlePeriodChange = async (event) => {
        setPeriod(event.target.value);
    }

    const handleComparativeUniverse = (data) => {
        setComparativeUniverse(data);
    }

    return (
        <>
        {userCountry !== "Chile" &&
            <IndustrialCard>
                <Box style={{ marginBottom: 10, flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                    <Text style={{ fontSize: 14, fontWeight: '700', color: '#464648', flex: 1 }}>{translateText("Avaliação - Valores Estimados e CAP Rate", language, translations, userCountry)}</Text>
                    <PopUpComparativeUniverseIndustrial handleComparativeUniverse={handleComparativeUniverse} />
                    <Select
                        value={period}
                        label={translateText("Período", language, translations, userCountry)}
                        handleChange={handlePeriodChange}
                        items={[{ value: 4, label: `4 ${translateText("Trimestres", language, translations, userCountry)}` }, { value: 12, label: `12 ${translateText("Trimestres", language, translations, userCountry)}` }, { value: 24, label: `24 ${translateText("Trimestres", language, translations, userCountry)}` }, { value: 36, label: `36 ${translateText("Trimestres", language, translations, userCountry)}` }]}
                    />
                    <Button
                        sx={{
                            backgroundColor: "#04577F",
                            color: '#FFF',
                            height: 40,
                            transition: '0.2s',
                            textTransform: "capitalize",
                            '&:hover': {
                                backgroundColor: "#04577F",
                                opacity: 0.7
                            }
                        }}
                        startIcon={<img src={reloadIcon} width={20} height={20} />}
                        onClick={() => handleReload()}
                    >
                        {translateText("Recarregar Valores", language, translations, userCountry)}
                    </Button>
                </Box>  
                <Box style={{ flexDirection: 'row', display: 'flex', justifyContent: 'center' }}>
                    <ChartCapRateIndustrial
                        comparativeUniverse={comparativeUniverse}
                        industrialId={industrialId}
                        period={period}
                        reloadTrigger={reloadTrigger}
                    />
                    <CapRateIndustrial
                        industrialId={industrialId}
                        comparativeUniverse={comparativeUniverse}
                        period={period}
                        handleVMVI={handleVMVI}
                        reloadTrigger={reloadTrigger}
                    />
                </Box>  
            </IndustrialCard>
        }
        </>
    )
}

